import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  signupModalOpened: false,
  email: null,
  password: null,
};
export const signup = createSlice({
  name: "signup",
  initialState,
  reducers: {
    handleSignupModalOpened: (state, action) => {
      state.signupModalOpened = !state.signupModalOpened;
    },
    setMailData: (state, action) => {
      state.email = action.payload;
    },
    setPasswordData: (state, action) => {
      state.password = action.payload;
    },
  },
});
export const { handleSignupModalOpened, setMailData, setPasswordData } = signup.actions;
export default signup.reducer;
